// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".install-comp-footer-btn-wrapper-cedbc{display:flex;justify-content:flex-end}.install-comp-footer-btn-wrapper-cedbc .install-comp-submit-btn-3173d{margin-left:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-btn-wrapper": "install-comp-footer-btn-wrapper-cedbc",
	"footerBtnWrapper": "install-comp-footer-btn-wrapper-cedbc",
	"submit-btn": "install-comp-submit-btn-3173d",
	"submitBtn": "install-comp-submit-btn-3173d"
};
export default ___CSS_LOADER_EXPORT___;
